import React from 'react';

import { ConstantPermissions } from 'contexts/useConstant';
import { useAuth } from 'hooks/useAuth';
import SaleSharedFile from 'components/Tvendo/Sale/Operations/SaleOrder/SaleSharedFile';

export default function SaleOrder() {
  const { hasPermission } = useAuth();

  // Con el permiso de anular con límite también se ve la X; el ws controla cuántos puede anular por día
  const deletePermission = hasPermission(ConstantPermissions.SALE_ORDERS_ANNULAR_LIMITED)
    ? ConstantPermissions.SALE_ORDERS_ANNULAR_LIMITED
    : ConstantPermissions.SALE_ORDERS_ANNULAR;

  return (
    <SaleSharedFile
      title="Listado de pedidos pendientes de programar"
      excelName="Pedidos_pendientes_programar"
      originType="SO"
      permission={{
        show: ConstantPermissions.SALE_ORDERS_SHOW,
        store: -1,
        delete: deletePermission,
      }}
    />
  );
}
